// 🔧 qr_codes.js
// ✅ Purpose: Public-facing manager guide for QR codes
// ✅ Features:
// - Explains how QR codes support event-day voting and participation
// - Covers entry, voting, auction, sponsor, and event QR concepts
// - Public and SEO-friendly
// - Uses the Dashboard-style LGV layout
// - Fully block-commented for clarity and future devs

import React from "react";
import { Link } from "react-router-dom";
import SeoHead from "../../../components/seo_head";

function QrCodesGuide() {
  return (
    <section id="top-content" className="container-fluid py-5">
      <SeoHead
        title="QR Codes Guide | Let's Go Vote"
        description="Learn how QR codes help attendees vote, view entries, open auctions, and access event pages with Let's Go Vote."
        path="/guides/qr-codes"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Guides", path: "/guides" },
          {
            name: "QR Codes",
            path: "/guides/qr-codes",
          },
        ]}
      />
      <div className="row mb-4">
        <div className="col text-start">
          <h1 className="display-5">📱 QR Codes</h1>
          <p className="lead text-muted">
            Make voting and event participation simple with scan-ready links.
          </p>
        </div>
      </div>

      <div className="white-section p-4 rounded shadow-sm bg-white">
        <section className="mb-5">
          <div className="alert alert-info text-start">
            <h5 className="mb-3">QR codes reduce event-day questions</h5>
            <p className="mb-0">
              QR codes let attendees scan and go directly to the right event,
              entry, ballot, auction item, sponsor page, or public information
              page.
            </p>
          </div>
        </section>

        <section className="mb-5">
          <h3 className="mb-3">Entry QR codes</h3>
          <p>
            Entry QR codes are placed near individual entries. When attendees
            scan the code, they can view the entry and begin the voting process.
          </p>
        </section>

        <section className="mb-5">
          <h3 className="mb-3">Event QR codes</h3>
          <p>
            Event QR codes can send attendees to the main event page, where they
            can find voting, entries, sponsors, volunteers, leaderboards, and
            other public event information.
          </p>
        </section>

        <section className="mb-5">
          <h3 className="mb-3">Auction QR codes</h3>
          <p>
            Silent auction items can use QR codes so bidders can open the item,
            review details, and place bids from their phone.
          </p>
        </section>

        <section className="mb-5">
          <h3 className="mb-3">Testing QR codes</h3>
          <p>
            Before printing, scan your QR codes from a phone and confirm each
            code opens the correct page. Testing early helps prevent event-day
            confusion.
          </p>
        </section>

        <section className="mb-0">
          <div className="alert alert-primary text-start mb-0">
            <h5 className="mb-3">Next recommended guide</h5>
            <p className="mb-3">
              Once QR codes are ready, review the event-day checklist.
            </p>

            <Link to="/guides/running-event-day" className="btn btn-primary">
              Continue to Running Event Day
            </Link>
          </div>
        </section>
      </div>
    </section>
  );
}

export default QrCodesGuide;